export default __webpack_public_path__ + "static/media/maternity-leave-policy-updated.58b7d197.pdf";